import React, {Fragment, Component } from 'react';
import { 
    FormDataConsumer,
    SelectInput ,
} from 'react-admin';
import { useForm } from 'react-final-form';
import TableCell from '@material-ui/core/TableCell';



const getValidatethis=(val, targetvalue, altvalidate, lid) => {
    let dummy= null;
    if(val && val === targetvalue){
        dummy = (document.getElementById(lid))?document.getElementById(lid).removeAttribute("style"):null; 
    }else if(val &&  altvalidate && val === altvalidate){  
        dummy = (document.getElementById(lid))?document.getElementById(lid).removeAttribute("style"):null; 
    }else{
        dummy = (document.getElementById(lid))? document.getElementById(lid).setAttribute("style", "color: red;"): null;
    }
    
    return val
}


const OrderOrigin = ({id,field,targetvalue,label,choices, formData, validate, altvalue, rowspan, ...rest }) => {
    const form = useForm();
    var rspan = (rowspan && rowspan > 1)? rowspan  : '1';
    return (
        <Fragment >
             <TableCell  align="left"  rowSpan={rspan}>
               {label}
                <SelectInput 
                    choices={choices}  
                    source={field} 
                    label=""  
                    id={id}
                    validate={validate}  
                    onChange={getValidatethis(formData[field], targetvalue, altvalue, id),
                      formData[field] = getValidatethis(formData[field], targetvalue, altvalue, id)
                      } 
                    {...rest}
                  /></TableCell>        
        </Fragment>
    );
};

const SelcectProQuest=({id,field,targetvalue,label,choices,validate,altvalue,rowspan, ...props}) => {

    return(
    <FormDataConsumer >
        {formDataProps => (
            <OrderOrigin  id={id} field={field} targetvalue={targetvalue} label={label} choices={choices} validate={validate} altvalue={altvalue} rowspan={rowspan} {...formDataProps} />
        )}
    </FormDataConsumer>
    )
    
}

export default SelcectProQuest